import { InterviewSession } from "../../../Interface/Index";
import aiInterviewService from "../../../Services/ai-interview.service";
import useInterviewRoundsHandlers from "./useInterviewRoundsHandlers";


interface RoundValidator {
  isUserUsingSameDevice: (session: InterviewSession) => Promise<boolean>;
  checkViolationLimitReached: (session: InterviewSession) => {
    isLimitReached: boolean;
    violationType: string;
  };
}

const VIOLATION_LIMITS: Record<string, number> = {
  fullscreen_exit: 1,
  keyboard_shortcut: 3,
  cursor_focus_switch: 3,
  multiple_tabs: 3,
  refresh_page: 1,
};

const useRoundValidator = (): RoundValidator => {
  const { getBrowserFingerPrint } = useInterviewRoundsHandlers();

  const isUserUsingSameDevice = async (session: InterviewSession): Promise<boolean> => {
    if (!session?.sessionToken) return true;

    if (session?.status !== "pending") return true;

    try {
      const browserFingerprint = await getBrowserFingerPrint();
      const sessionToken = await aiInterviewService.getSessionToken(
        session._id,
        browserFingerprint
      );
      return sessionToken === session.sessionToken;
    } catch (error) {
      console.error("Error in isUserUsingSameDevice:", error);
      return false;
    }
  };

  const checkViolationLimitReached = (
    session: InterviewSession
  ): { isLimitReached: boolean; violationType: string } => {
    const activityLogs = session.activityLogs || [];

    for (const [eventType, limit] of Object.entries(VIOLATION_LIMITS)) {
      const count = activityLogs.filter(
        (log) => log.event === eventType
      ).length;
      if (count >= limit) {
        return {
          isLimitReached: true,
          violationType: eventType,
        };
      }
    }

    return {
      isLimitReached: false,
      violationType: "",
    };
  };

  return {
    isUserUsingSameDevice,
    checkViolationLimitReached,
  };
};

export default useRoundValidator;
